/**
 * Central placeholder URLs for the landing page.
 * Replace each value before production launch (keep `#` until real URLs exist).
 */
/** App Store download URL */
export const IOS_APP_URL = '#';

/** Google Play download URL */
export const ANDROID_APP_URL = '#';

/** Web signup or deep link for “Create your gift page” CTAs */
export const CREATE_GIFT_PAGE_URL = '#';

export function isAppLinkConfigured(url: string): boolean {
    const trimmed = url.trim();
    return trimmed !== '' && trimmed !== '#';
}
